import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNoneGlyph from './svgs/NoneGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var noneGlyph = (props => useIcon(SvgNoneGlyph, SvgNoneGlyph, props));

export { noneGlyph as default };
